import gql from 'graphql-tag';

export default gql`
  mutation toggleTierMutation($input: RelayTogglePausePriceTierInput!) {
    toggleTier(input: $input) {
      success
    }
  }
`;
